(() => {
  'use strict';
  document.querySelectorAll('[data-hs-buscador]').forEach(form => {
    const campo = form.querySelector('[data-hs-sugerencias-campo]');
    const panel = form.querySelector('[data-hs-sugerencias]');
    const lista = panel.querySelector('[role=listbox]');
    const todos = panel.querySelector('[data-hs-ver-resultados]');
    const estado = panel.querySelector('[data-hs-sugerencias-estado]');
    let temporizador; let peticion; let indice = -1; let version = 0;
    const cerrar = () => {
      panel.hidden = true;
      campo.setAttribute('aria-expanded', 'false');
      campo.removeAttribute('aria-activedescendant');
      indice = -1;
    };
    const cancelar = () => { clearTimeout(temporizador); peticion?.abort(); version++; };
    const seleccionar = nuevo => {
      const opciones = Array.from(lista.children);
      indice = (nuevo + opciones.length) % opciones.length;
      opciones.forEach((el, i) => el.setAttribute('aria-selected', String(i === indice)));
      campo.setAttribute('aria-activedescendant', opciones[indice].id);
      opciones[indice].scrollIntoView({ block: 'nearest' });
    };
    campo.addEventListener('input', () => {
      cancelar();
      const q = campo.value.trim();
      if (q.length < 2) { cerrar(); return; }
      const actual = version;
      temporizador = setTimeout(async () => {
        peticion = new AbortController();
        try {
          const raiz = window.Shopify?.routes?.root || '/';
          const parametros = new URLSearchParams({ q, 'resources[type]': 'product', 'resources[limit]': '6' });
          const respuesta = await fetch(`${raiz}search/suggest.json?${parametros}`, { signal: peticion.signal });
          if (!respuesta.ok) throw new Error('No se pudieron cargar las sugerencias.');
          const datos = await respuesta.json();
          if (actual !== version || document.activeElement !== campo) return;
          lista.replaceChildren();
          indice = -1; campo.removeAttribute('aria-activedescendant');
          datos.resources.results.products.forEach((producto, i) => {
            const item = document.createElement('li');
            item.id = `hs-sugerencia-${i}`;
            item.setAttribute('role', 'option');
            item.setAttribute('aria-selected', 'false');
            const enlace = document.createElement('a');
            enlace.href = producto.url;
            enlace.tabIndex = -1;
            const src = typeof producto.image === 'string' ? producto.image : producto.featured_image?.url || producto.image?.url;
            if (src) {
              const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 48; img.height = 48; enlace.append(img);
            }
            const titulo = document.createElement('span'); titulo.textContent = producto.title;
            const precio = document.createElement('span'); precio.className = 'money';
            // Predictive Search devuelve unidades monetarias, no centavos.
            precio.textContent = `$${Number(producto.price).toFixed(2)}`;
            const iva = document.createElement('span'); iva.className = 'hs-iva-note'; iva.textContent = 'Este precio no incluye IVA';
            enlace.append(titulo, precio, iva); item.append(enlace); lista.append(item);
          });
          todos.href = `${form.action}?${new URLSearchParams({ q, type: 'product' })}`;
          estado.classList.toggle('hs-solo-lectores', lista.children.length > 0);
          estado.textContent = lista.children.length ? `${lista.children.length} sugerencias` : `Sin resultados para "${q}"`;
          panel.hidden = false; campo.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (actual === version) cerrar(); // El formulario conserva la búsqueda normal.
        }
      }, 200);
    });
    campo.addEventListener('keydown', evento => {
      if (evento.key === 'Escape') { cancelar(); cerrar(); return; }
      if (!panel.hidden && lista.children.length && ['ArrowDown', 'ArrowUp'].includes(evento.key)) {
        evento.preventDefault(); seleccionar(indice < 0 ? (evento.key === 'ArrowDown' ? 0 : lista.children.length - 1) : indice + (evento.key === 'ArrowDown' ? 1 : -1));
      }
      if (evento.key === 'Enter' && !panel.hidden && indice >= 0) {
        evento.preventDefault(); lista.children[indice].querySelector('a').click();
      }
    });
    form.addEventListener('submit', () => { cancelar(); cerrar(); });
    document.addEventListener('click', evento => { if (!form.contains(evento.target)) { cancelar(); cerrar(); } });
    form.addEventListener('focusout', () => {
      setTimeout(() => { if (!form.contains(document.activeElement)) { cancelar(); cerrar(); } }, 0);
    });
  });
})();
